import { mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
// import TabsComponent from '@/agilis/components/Tabs/Tabs.vue'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'
import DataTableV2Paginated from '@/agilis/components/DataTableV2Paginated/DataTableV2Paginated.vue'
import DocumentEditor from '@/agilis/components/DocumentEditor/DocumentEditor.vue'

export default {
  name: 'AppSettings',

  // TabsComponent,
  components: {
    UnStyledLink,
    DataTableV2Paginated,
    DocumentEditor
  },

  data () {
    return {
      settings: {},
      json: {}
    }
  },

  created: async function () {
    this.settings = Configuration.settings.getAvailableApplicationSettings(this.applicationId)
  },

  computed: {
    ...mapGetters({
      computedApplications: 'configurationStore/applications',
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId'
    }),

    tabIds () {
      return Configuration.settings.getAvailableApplicationSettingsId(this.applicationId)
    },

    rerenderKey () {
      return this.tabIds.join('__')
    },

    applicationDataTableOverride () {
      const app = Configuration.getApplication(this.applicationId)
      return app.dataTableComponentId
    },

    trackerTypesTabItemStyle () {
      return ''
    },

    activeTabId () {
      return this.$route.params.trackerTypeId
    },

    activeTab () {
      return (this.activeTabId)
        ? this.tabIds.indexOf(this.activeTabId)
        : 0
    },

    settingId () {
      return this.tabIds[this.activeTab]
    },

    setting () {
      return this.settings[this.settingId]
    },

    document () {
      return Configuration.document.getDocument(this.applicationId, this.setting.document)
    },

    tabBarIsVisible () {
      return false
    },

    tabItemStyle () {
      return `height: calc(100vh - 64px); overflow: auto; margin-left: 2px;`
    }
  },

  methods: {
    overrideComponentId (trackerTypeId) {
      return this.settings[trackerTypeId].dataTableComponentId || this.applicationDataTableOverride
    },

    trackerTitle (trackerTypeId) {
      return this.$t(this.settings[trackerTypeId].name)
    },

    trackerDescription (trackerTypeId) {
      return this.$t(this.settings[trackerTypeId].description)
    },

    trackerApi (trackerTypeId) {
      return this.trackerDatatableConfiguration(trackerTypeId).api?.url
        ? this.trackerDatatableConfiguration(trackerTypeId).api.url
        : this.$axios.agilisUrlTracker(this.applicationId, trackerTypeId)
    },

    trackerDatatableConfiguration (trackerTypeId) {
      return Configuration.datatable.getSettingDatatable({
        applicationId: this.applicationId,
        settingId: trackerTypeId
      })
    },

    trackerType (trackerTypeId) {
      return this.settings[trackerTypeId]
    },

    componentResolverProps (trackerTypeId) {
      return {
        viewComponentId: 'DataTableV2Paginated',
        configuration: this.trackerDatatableConfiguration(trackerTypeId),
        propTitle: this.trackerTitle(trackerTypeId),
        description: this.trackerDescription(trackerTypeId),
        api: this.trackerApi(trackerTypeId)
      }
    },

    tabHref (settingId) {
      const tabId = this.settings[settingId].tabId
      return `/application/${this.applicationId}/settings/${tabId}/${settingId}`
    },

    handleTabClick (settingId) {
      this.$router.push({
        name: 'applicationSettings',
        params: {
          applicationId: this.applicationId,
          tabId: this.settings[settingId].tabId,
          trackerTypeId: settingId
        }
      })
    },

    getTabName (tabId) {
      const label = this.settings[tabId].name
      return label ? this.$t(label) : tabId
    }
  }
}
